import "swiper/css";
import "swiper/css/effect-fade";
import Image from "../assets/Mwende.jpeg";
import { Link } from "react-router-dom";

function About() {
  return (
    <div className="bg-white font-poppins">
      <div className="container mx-auto px-5 md:px-10 py-20">
        <div className="md:flex md:space-x-10 items-center">
          
          {/* Image Section */}
          <div className="md:w-1/2 mb-10 md:mb-0">
            <img 
              src={Image} 
              alt="Mwende Kivale - Advocate and Lawyer" 
              className="rounded-lg  transition-transform duration-300 transform hover:scale-105 border-4 border-transparent"
            />
          </div>

          {/* Text Section */}
          <div className="md:w-1/2 space-y-6 text-center md:text-left">
            <h2 className="text-secondary text-4xl font-extrabold">About Me</h2>
            <p className="text-[#626262] text-lg md:text-xl leading-relaxed">
              I hold a Bachelor&apos;s degree in Food, Nutrition, and Dietetics, and I am passionate about improving health through nutrition. My experience includes managing chronic conditions like diabetes and hypertension, focusing on child nutrition, and participating in initiatives such as the Baby-Friendly Hospital Initiative. I specialize in diet therapy, nutrition counseling, and meal planning, and I stay updated on nutrition trends to provide innovative, healthy recipes for optimal health outcomes.
            </p>
            <div className="mt-5 text-center">
              <Link to="https://calendly.com/mwendekivale">
                <button className="bg-secondary border-2 border-secondary px-8 py-4 rounded-lg font-bold text-white transition-all duration-300 transform hover:bg-white hover:text-secondary hover:shadow-lg">
                  Book a Call
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
